import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import {
  HandexInstance,
  HanjinInstance,
  LogenInstance,
  LotteInstance,
} from "../instance";
import dayjs from "dayjs";
import { barcodeDataState } from "../../stores/barcode/barcodeDataState";
import Swal from "sweetalert2";

// 운송장 조회 API
const useGetBarcodeData = ({ startDate, endDate, workType, barcode, resultCode }) => {
  const login = useRecoilValue(loginState);
  const setBarcodeData = useSetRecoilState(barcodeDataState);

  // 조회 조건에 맞는 데이터만 필터링
  const filterData = (data) => {
    return data
      .filter((item) => {
        const itemDate = dayjs(item.scandate).format("YYYY-MM-DD");
        const matchesDate = itemDate >= startDate && itemDate <= endDate;
        const matchesWorkType = workType === "전체" || item.tm_dv === workType;
        const matchesBarcode = !barcode || item.barcode.includes(barcode);

        const matchesResultCode =
          resultCode === "전체" || String(item.result_no) === resultCode;

        return matchesDate && matchesWorkType && matchesBarcode && matchesResultCode;
      })
      .map((item) => ({
        ...item,
        result_no: item.result_no || "",
        result_msg: item.result_msg || "",
        scannername: item.scannername || "",
      }));
  };

  const mutationOptions = {
    onSuccess: (data) => {
      if (data.result === "00" || data.result === "77") {
        const filteredData = filterData(data.data);
        setBarcodeData(filteredData);
        Swal.fire({
          icon: "success",
          title: "운송장 데이터를 조회했습니다.",
          confirmButtonText: "확인",
        });
      }
    },
    onError: (error) => {
      Swal.fire({
        icon: "warning",
        title: "운송장 데이터를 조회하는 중 문제가 발생했습니다.",
        confirmButtonText: "확인",
      });
      console.log(error);
    },
  };

  const postData = {
    api: "dvInAll",
    data: [
      {
        start_time: `${dayjs(startDate).format("YYYY-MM-DD")} 00:00:00`,
        end_time: `${dayjs(endDate).format("YYYY-MM-DD")} 23:59:59`,
        bran_cd: login.branchCode,
        longTime: "",
        car_num: "",
        company: login.company,
      },
    ],
  };

  let mutationFn;

  if (login.company === "LOGEN") {
    mutationFn = () => LogenInstance.post("/lose", postData);
  } else if (login.company === "LOTTE") {
    mutationFn = () => LotteInstance.post("/lose", postData);
  } else if (login.company === "HANJIN") {
    mutationFn = () => HanjinInstance.post("/lose", postData);
  } else if (login.company === "HANDEX") {
    mutationFn = () => HandexInstance.post("/lose", postData);
  } else {
    mutationFn = () => {
      Swal.fire({
        icon: "warning",
        title: "고객사가 올바르지 않습니다.",
        confirmButtonText: "확인",
      });
    };
  }

  return useMutation("getAmount", mutationFn, mutationOptions);
};

export default useGetBarcodeData;
